export default function feedback_form() {
    const submit_button = document.getElementById('send-request-block');
    const close_button = document.getElementById('send-request-block-close');
    if(!submit_button) {
        return;
    }
    submit_button.addEventListener('click', (e) => {
        e.preventDefault();

        const form = e.target.closest('form');

        const success = form.parentElement.querySelectorAll('[data-type="send-request-success"]');
        const name = form.querySelector('input[name="name"]').value;
        const phone = form.querySelector('input[name="phone"]').value;

        form.querySelector('input[name="name"]').parentElement.classList.remove('error');
        form.querySelector('input[name="phone"]').parentElement.classList.remove('error');

        if (!name || !phone) {
            if (!name) {
                form.querySelector('input[name="name"]').parentElement.classList.add('error');
            }
            if (!phone) {
                form.querySelector('input[name="phone"]').parentElement.classList.add('error');
            }

            return;
        }

        fetch('/post-feedback', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: new URLSearchParams({
                name: name,
                phone: phone
            })
        })
            .then(response => response.json())
            .then(response => {
                if (response.result && response.result.length > 0) {
                    response.result.forEach(error => {
                        const input = document.querySelector(`input[name="${error.field}"]`);
                        if (input) {
                            input.parentElement.classList.add('error');
                        }
                    });
                } else {
                    form.classList.add('hidden');
                    success.forEach(element => {
                        element.classList.remove('hidden');
                    });
                    name.value = '';
                    phone.value = '';

                    setTimeout(() => {
                        form.classList.remove('hidden');
                        success.forEach(element => {
                            element.classList.add('hidden');
                        });
                    }, 3000);
                }
            });
    });

    close_button.addEventListener('click', (e) => {
        e.target.closest('.request_form')
            .querySelector('[data-type="send-request"]').classList.remove('hidden');
        e.target.closest('.request_form')
            .querySelector('[data-type="send-request-success"]').classList.add('hidden');
    })
}
